(() => {
  const component = document.querySelector('[data-final-drive-fitment-review]');
  if (!component) return;

  const product = {
    id: component.dataset.productId || '',
    handle: component.dataset.productHandle || '',
    title: component.dataset.productTitle || ''
  };
  const requestStorageKey = `ssc_final_drive_fitment_request_${product.id}`;
  const startedStorageKey = `${requestStorageKey}_started`;
  const submittedStorageKey = `${requestStorageKey}_submitted`;
  const requestTypeStorageKey = `${requestStorageKey}_request_type`;
  const quoteStartedStorageKey = `${requestStorageKey}_quote_started`;
  const quoteSubmittedStorageKey = `${requestStorageKey}_quote_submitted`;

  function createRequestId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `fd-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // The form remains functional when session storage is unavailable.
    }
  }

  function getRequestId() {
    const existing = storageGet(requestStorageKey);
    if (existing) return existing;

    const requestId = createRequestId();
    storageSet(requestStorageKey, requestId);
    return requestId;
  }

  const requestId = getRequestId();
  const successStorageKey = `${requestStorageKey}_success_${requestId}`;

  function isNonLiveTheme() {
    return component.dataset.designMode === 'true' || ['development', 'unpublished'].includes(
      String(window.Shopify?.theme?.role || '').toLowerCase()
    );
  }

  function track(eventName, detail = {}) {
    const eventDetail = {
      request_id: requestId,
      product_id: product.id,
      product_handle: product.handle,
      ...detail
    };

    if (isNonLiveTheme()) {
      window.sscFinalDriveDebugEvents = window.sscFinalDriveDebugEvents || [];
      window.sscFinalDriveDebugEvents.push({ event: `ssc_${eventName}`, ...eventDetail });
      return;
    }

    document.dispatchEvent(new CustomEvent(`ssc:${eventName}`, { detail: eventDetail }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `ssc_${eventName}`, ...eventDetail });

    try {
      window.Shopify?.analytics?.publish?.(`ssc_${eventName}`, eventDetail);
    } catch (error) {
      console.warn('Final-drive pilot analytics publish failed.', error);
    }
  }

  function populateAttributionFields() {
    const requestInput = component.querySelector('[data-final-drive-request-id]');
    const requestOutput = component.querySelector('[data-final-drive-request-id-output]');
    if (requestInput) requestInput.value = requestId;
    if (requestOutput) requestOutput.textContent = requestId;

    const landingInput = component.querySelector('[data-final-drive-landing-url]');
    const referrerInput = component.querySelector('[data-final-drive-referrer]');
    if (landingInput) landingInput.value = window.location.href;
    if (referrerInput) referrerInput.value = document.referrer || '';

    const params = new URLSearchParams(window.location.search);
    component.querySelectorAll('[data-final-drive-utm]').forEach(input => {
      input.value = params.get(input.dataset.finalDriveUtm) || '';
    });

    document.querySelectorAll('[data-final-drive-cart-request-id]').forEach(input => {
      input.value = requestId;
    });
  }

  function trackStartOnce(source) {
    if (storageGet(startedStorageKey)) return;
    storageSet(startedStorageKey, '1');
    track('final_drive_fitment_review_start', { source });
  }

  document.querySelectorAll('[data-final-drive-fitment-open]').forEach(link => {
    link.addEventListener('click', () => trackStartOnce('product_cta'));
  });

  document.querySelectorAll('[data-final-drive-phone-click]').forEach(link => {
    link.addEventListener('click', () => track('final_drive_phone_click', { source: 'product_cta' }));
  });

  const form = component.querySelector('form');
  if (form) {
    populateAttributionFields();

    const requestType = form.querySelector('[data-final-drive-request-type]');
    const quoteFields = form.querySelector('[data-final-drive-quote-fields]');
    const quoteRequiredInputs = Array.from(form.querySelectorAll('[data-final-drive-quote-required]'));

    function syncQuoteFields(trackSelection = false) {
      const requestsDeliveredQuote = requestType?.value === 'Fitment review and delivered quote';
      if (quoteFields) {
        quoteFields.hidden = !requestsDeliveredQuote;
        quoteFields.setAttribute('aria-hidden', String(!requestsDeliveredQuote));
      }
      quoteRequiredInputs.forEach(input => {
        input.required = requestsDeliveredQuote;
      });

      if (requestType?.value) {
        storageSet(requestTypeStorageKey, requestType.value);
      }

      if (trackSelection && requestsDeliveredQuote && !storageGet(quoteStartedStorageKey)) {
        storageSet(quoteStartedStorageKey, '1');
        track('final_drive_quote_start');
      }
    }

    requestType?.addEventListener('change', () => syncQuoteFields(true));
    syncQuoteFields();

    form.addEventListener('focusin', () => trackStartOnce('form_interaction'), { once: true });
    form.addEventListener('submit', () => {
      const requestsDeliveredQuote = requestType?.value === 'Fitment review and delivered quote';
      if (requestType?.value) {
        storageSet(requestTypeStorageKey, requestType.value);
      }

      if (!storageGet(submittedStorageKey)) {
        storageSet(submittedStorageKey, '1');
        track('final_drive_fitment_review_submit', {
          has_machine_year: Boolean(form.querySelector('#final-drive-machine-year')?.value.trim()),
          has_machine_serial: Boolean(form.querySelector('#final-drive-machine-serial')?.value.trim()),
          has_motor_tag: Boolean(form.querySelector('#final-drive-motor-tag')?.value.trim()),
          has_oem_number: Boolean(form.querySelector('#final-drive-oem-number')?.value.trim()),
          requests_delivered_quote: requestsDeliveredQuote
        });
      }

      if (requestsDeliveredQuote && !storageGet(quoteSubmittedStorageKey)) {
        storageSet(quoteSubmittedStorageKey, '1');
        track('final_drive_quote_submit');
      }
    });
  }

  const success = component.querySelector('[data-final-drive-fitment-success]');
  if (success && !storageGet(successStorageKey)) {
    storageSet(successStorageKey, '1');
    track('final_drive_fitment_review_success', {
      requests_delivered_quote: storageGet(requestTypeStorageKey) === 'Fitment review and delivered quote'
    });
    window.requestAnimationFrame(() => success.focus());
  }

  document.addEventListener('ssc:product-added-to-cart', event => {
    track('final_drive_add_to_cart', {
      variant_id: String(event.detail?.variantId || ''),
      quantity: Number(event.detail?.quantity || 1)
    });
  });
})();
